import { Box, styled } from '@mui/material';

import { TextField } from 'theSource/components/Form/components/TextField/TextField';

export const ChangePasswordWrapperStyled = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(6),
}));

export const TextFieldStyled = styled(TextField)({
  borderTop: '1px solid #707178',
  borderRadius: '4px',
});
